
  import { defineComponent, computed } from 'vue';
  import { InspectionActivity } from '@/entities/activity/model';
  import { CreatedAt } from '@/ui/components/activityLogs/common/CreatedAt';
  import { t } from '@/ui/i18n/i18n';
  import { boldifyStringArray } from '@/ui/components/activityLogs/helpers';

  interface ApprovalApprovedProps {
    resourceName: string;
    log: InspectionActivity;
  }

  export default defineComponent<ApprovalApprovedProps>({
    name: 'ApprovalApproved',
    components: {
      CreatedAt,
    },
    props: ['resourceName', 'log'],
    setup(props) {
      const activityMessage = computed(() => {
        const { comment } = props.log.payload;
        const transKey = comment
          ? 'activity-logs.approval-approved-comment'
          : 'activity-logs.approval-approved';
        return t(transKey, {
          username: boldifyStringArray([props.log.user?.name ?? '']),
          comment: comment as string,
        });
      });

      return {
        activityMessage,
      };
    },
  });
